export default __webpack_public_path__ + "static/media/template_business-man__0003_24---RickSolo.cb368439.png";